export default "__VITE_ASSET__hKP7tVYk__"